import { Outlet } from "react-router-dom";

import { useThemePreferenceSync } from "@src/features/theme";

import { useMobileOktaHandoffListener } from "../../../application/v2/useMobileOktaHandoff";

export function RootV2Route() {
  useThemePreferenceSync();
  useMobileOktaHandoffListener();

  return (
    <div className="theme-v2 min-h-full bg-background text-foreground font-sans">
      <Outlet />
    </div>
  );
}
